<template>
  <div class="viewTable">
    <!-- 搜索 -->
    <div id="searchBox">
      <slot name="adSearch"/>
      <div class="moreSearch">
        <span v-if="searchs.length > 4">
          <a v-if="!searchShow" class="actionDown" @click="toggleMore">
            展开
            <i class="el-icon-arrow-down"/>
          </a>
          <a v-else class="actionDown" @click="toggleMore">
            收起
            <i class="el-icon-arrow-up"/>
          </a>
        </span>
        <el-button style="height: 29px" type="primary" @click="loadData(1)">查询</el-button>
        <el-button style="height: 29px" type="primary" plain @click="resetHandle">重置</el-button>
      </div>
    </div>
    <!-- 按钮 -->
    <div v-if="toolBarShow" id="toolBar">
      <div class="left">
        <el-button v-if="limits.addAuth" style="float: left;" type="primary" @click="$emit('addOrEdit')">新建</el-button>
        <slot style="float: left;" name="otherBtn"/>
      </div>
      <div class="right">
        <!-- <div title="导入">
          <i class="el-icon-upload2"/>
        </div> -->
        <div title="导出" @click="openExportDialog">
          <i class="el-icon-download"/>
        </div>
        <div title="刷新" @click="loadData(1)">
          <i class="el-icon-refresh"/>
        </div>
        <div @click="fullScreen">
          <i v-if="!isFullscreen" title="全屏" class="el-icon-full-screen"/>
          <i v-else title="还原" class="el-icon-aim"/>
        </div>
        <div title="列设置" @click="columnsVisibleOpen">
          <i class="el-icon-menu"/>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <Table
        style="margin-top: 5px"
        :table-select="tableSelect"
        :height="height"
        :loading="loading"
        :border="border"
        :stripe="stripe"
        :columns="columns"
        :data="tableData"
        :max-height="maxHeight"
        :row-class-name="tableRowClassName"
        @on-selection-change="selectHandle"
        @on-column-width-resize="columnResize"
        @on-row-click="rowClick">
      <template slot="radio" slot-scope="{ row, index }">
        <el-radio v-model="currentRowIndex" :label="index"/>
      </template>
      <template v-if="tableAction" slot="action" slot-scope="{ row }">
        <el-button
            v-if="limits.editAuth"
            type="primary"
            :disabled="$parent.otherAuth ? $parent.otherAuth(row).editAuth : false"
            @click="$emit('addOrEdit', row)">
          编辑
        </el-button>
        <slot name="actionBtn" :row="row"/>
        <el-button
            v-if="limits.delAuth"
            :disabled="$parent.otherAuth ? $parent.otherAuth(row).delAuth : false"
            type="danger"
            @click="deleteHandle(row)">
          删除
        </el-button>
      </template>
    </Table>
    <!-- 分页 -->
    <div style="margin-top: 13px; text-align: right;display:flex;justify-content: flex-end;">
      <div style="font-size: 13px;margin-right: 50px;margin-top:7px;">
        <span>{{tableFooterMsg}}</span>
      </div>
      <el-pagination
          :current-page="pagination.currentPage"
          :page-sizes="pagination.pageSizeOptions"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"/>
    </div>
    <!-- 列设置 -->
    <el-dialog
        v-if="columnsVisible"
        v-el-drag-dialog
        title="列设置"
        :visible.sync="columnsVisible"
        width="800px">
      <div id="sortEl">
        <el-checkbox
            v-for="item in allColumns"
            :key="item.name"
            style="margin-bottom: 10px"
            :checked="item.checked"
            :label="item.name"
            @change="checkedChange(item.name)">
          {{item.desc}}
        </el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setColumns()">初始化设置</el-button>
        <el-button type="primary" @click="setColumns(allColumns)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导出 -->
    <el-dialog v-el-drag-dialog title="导出数据" :visible.sync="exportVisible" width="800px">
      <el-form ref="exportForm" :model="model" :rules="rules" label-width="80px">
        <el-form-item label="导出字段" prop="exportFields">
          <el-checkbox-group v-model="model.exportFields">
            <el-checkbox v-for="item in allColumns" :key="item.name" :label="item.name">
              {{item.desc}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportVisible = false">取 消</el-button>
        <el-button type="primary" :loading="exportLoading" @click="sureExport">导 出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Sortable from "sortablejs";
  import moment from "moment";

  export default {
    props: {
      module: {
        type: String,
        required: true,
      },
      url: {
        type: String,
        required: true,
      },
      // 列属性
      columnsProperty: {
        type: Array,
        default: () => [],
      },
      // 过滤条件
      filter: {
        type: Object,
      },
      // 边框
      border: {
        type: Boolean,
        default: true,
      },
      // 斑马线
      stripe: {
        type: Boolean,
        default: true,
      },
      // 表格高度：如果不设置则计算最大高度，设置则不计算
      height: {
        type: [Number, String],
        default: 0,
      },
      // 可选择
      tableSelect: {
        type: Boolean,
        default: true,
      },
      // 操作栏
      tableAction: {
        type: Boolean,
        default: true,
      },
      tableFooterMsg: {
        type: String,
        default: "",
      },
      // 新增、编辑、删除权限
      limits: {
        type: Object,
        default: () => {
          return {
            addAuth: false,
            editAuth: false,
            delAuth: false,
          };
        },
      },
      // 工具栏
      toolBarShow: {
        type: Boolean,
        default: true,
      },
    },

    data() {
      return {
        filterCopy: JSON.stringify(this.filter),
        currentRowIndex: 0,
        columns: [],
        allColumns: [],
        tableData: [],
        loading: false,
        columnsVisible: false,
        pagination: {
          currentPage: 1,
          pageSize: 20,
          pageSizeOptions: [10, 20, 50, 100],
        },
        maxHeight: 0,
        isFullscreen: false,
        exportVisible: false,
        model: {
          exportNum: 100000,
          exportFields: [],
        },
        rules: {
          exportNum: [
            {required: true, message: "请输入导出数量", trigger: "blur"},
            {pattern: /^[1-9]\d*$/, message: "请输入大于0的整数", trigger: "change"},
          ],
          exportFields: [{type: "array", required: true, message: "请至少选择一个导出字段", trigger: "change"}],
        },
        exportLoading: false,
        selection: [], // 表格选中的数据
        searchShow: false,
        searchs: [],
      };
    },

    mounted() {
      this.tableFilter();
      this.tableHeight();
      this.getAllColumns();
      // 窗口缩放 重新计算表格的最大高度
      window.onresize = () => {
        this.tableHeight();
      };
      let node = document.getElementById("searchBox");
      this.searchs = node.getElementsByClassName("el-form-item");
      for (let i = 0; i < this.searchs.length; i++) {
        if (i > 3) {
          this.searchs[i].style.display = "none";
        }
      }
    },

    methods: {
      getImgSrc(imgPath, index) {
        if (imgPath) {
          this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(imgPath)}`).then((res) => {
            if (res.success) {
              this.tableData[index].imgPath = res.data;
            }
          });
        }
      },
      getAllColumns() {
        this.loading = true;
        // 获取所有可用列
        this.$http.get("basic", `${this.url}`, "", {"All-Fields": 1}).then((res) => {
          if (res.success) {
            this.columns = [];
            this.allColumns = res.data;
            // 获取用户配置列
            this.$http.get("basic", `userHabits?habitType=10&code=${this.url}`).then((resp) => {
              if (resp.data && resp.data.description) {
                let userColumns = JSON.parse(resp.data.description);
                userColumns.forEach((item, i) => {
                  let index = this.allColumns.findIndex((i) => i.name === item.name);
                  if (index === -1) {
                    userColumns.splice(i, 1);
                  } else {
                    item.desc = this.allColumns[index].desc;
                  }
                });
                this.allColumns = userColumns;
                let fixedColumn = 1;
                this.allColumns.forEach((item) => {
                  if (item.checked) {
                    // this.columns.push({
                    //   title: item.desc,
                    //   key: item.name,
                    //   resizable: true,
                    //   minWidth: 60,
                    //   width: item.width,
                    // });

                    let curCol = {
                      title: item.desc,
                      key: item.name,
                      resizable: true,
                      minWidth: 180,
                      width: item.width,
                    };

                    if (fixedColumn < 4) {
                      curCol.fixed = "left";
                    }
                    this.columns.push(curCol);
                    fixedColumn++;
                  }
                });
              } else {
                // 没有设置过列
                this.allColumns.forEach((item) => {
                  this.columns.push({title: item.desc, key: item.name, resizable: true, minWidth: 180, width: ""});
                  item.checked = true;
                });
              }

              this.columnsProperty.forEach((item) => {
                let findIndex = this.columns.findIndex((i) => item.key === i.key);
                if (findIndex !== -1) {
                  let temp = {...this.columns[findIndex], ...item};
                  if (this.columns[findIndex].width) {
                    temp.width = this.columns[findIndex].width;
                  }
                  // this.columns[findIndex] = temp;
                  this.$set(this.columns, findIndex, temp);
                } else if (item.key === "action") {
                  item.title = "操作";
                  this.columns.push(item);
                } else if (item.key === "radio") {
                  // console.log(item)
                  this.columns.unshift(item);
                } else if (item.type === "index") {
                  // console.log(item)
                  this.columns.unshift(item);
                } else if (item.type === "expand") {
                  // console.log(item)
                  this.columns.unshift(item);
                }
              });


              // table可选择
              if (this.tableSelect) {
                this.columns.unshift({type: "selection", width: 60, align: "center", fixed: "left"});
              }
              this.loadData(1);
            });
          }
        });
      },

      // 获取数据
      loadData(pageNum) {
        let that = this;
        if (pageNum) {
          that.pagination.currentPage = pageNum;
          // that.pagination.pageNum = pageNum;
        }
        that.loading = true;
        let params = Object.assign({
          pageSize: that.pagination.pageSize,
          pageNum: that.pagination.currentPage,
        }, that.filter);
        that.$http
            .get(`${that.module}`, `${that.url}`, params)
            .then((res) => {
              if (res.success) {
                that.tableData = res.data.records;
                that.pagination.total = res.data.total;
                //更新搜索数据
                this.updateFilter(params);
              }
              if (that.url === "materials") {
                that.tableData.forEach((item, index) => {
                  that.getImgSrc(item.imgPath, index);
                });
              }
              that.loading = false;
              that.$emit("update");
            })
            .catch(() => {
              that.loading = false;
            });
      },

      // 列设置模态框
      columnsVisibleOpen() {
        this.columnsVisible = true;
        this.$nextTick(() => {
          this.sortColumns();
        });
      },

      checkedChange(name) {
        this.allColumns.forEach((item) => {
          if (item.name === name) {
            item.checked = !item.checked;
          }
        });
      },

      // 列排序
      sortColumns() {
        const that = this;
        const el = document.getElementById("sortEl");
        const options = {
          animation: 150,
          onEnd: function(evt) {
            that.allColumns.splice(evt.newIndex, 0, that.allColumns.splice(evt.oldIndex, 1)[0]);
            const newArr = that.allColumns.slice(0);
            that.allColumns = [];
            that.$nextTick(function() {
              that.allColumns = newArr;
            });
          },
        };
        Sortable.create(el, options);
      },

      // 设置列显示
      setColumns(string) {
        const params = {
          habitType: 10,
          code: this.url,
          description: string ? JSON.stringify(string) : "",
        };
        this.$http.post("basic", "userHabits", params).then((res) => {
          if (res.success) {
            this.$message.success("设置成功");
            this.columnsVisible = false;
            this.getAllColumns();
          }
        });
      },

      // 拖拽调整列宽
      columnResize() {
        this.columns.forEach((item) => {
          this.allColumns.forEach((i) => {
            if (item.key === i.name) {
              if (item.width) {
                i.width = parseInt(item.width);
              }
            }
          });
        });
        const params = {
          habitType: 10,
          code: this.url,
          description: JSON.stringify(this.allColumns),
        };
        this.$http
            .post("basic", "userHabits", params)
            .then(() => {
            })
            .catch(() => {
            });
      },

      // 切换分页
      handleCurrentChange(page) {
        this.pagination.currentPage = page;
        this.loadData(page);
      },

      // 切换分页条数
      handleSizeChange(pageSize) {
        this.pagination.pageSize = pageSize;
        // this.pagination.pageNum = 1;
        this.pagination.currentPage = 1;
        this.filter.pageNum = 1;
        this.filter.pageSize = pageSize;
        this.loadData(1);
      },

      //获取搜索条件
      tableFilter() {
        // 获取用户配置列
        this.$http.get("basic", `userHabits?habitType=20&code=${this.url}`).then((resp) => {
          if (resp.data) {
            this.filter = Object.assign(this.filter, JSON.parse(resp.data.description));
            // this.filterCopy = JSON.stringify(this.filter);
            if (this.filter.pageSize) {
              this.pagination.pageSize = this.filter.pageSize;
            }
          }
        });
      },

      updateFilter(filter) {
        // delete filter.pageSize;
        delete filter.pageNum;
        const params = {
          habitType: 20,
          code: this.url,
          description: JSON.stringify(filter),
        };
        this.$http
            .post("basic", "userHabits", params)
            .then(() => {
            })
            .catch(() => {
            });
      },

      // 设置表格最大高度
      tableHeight() {
        if (!this.height) {
          const clientHeight = document.body.clientHeight;
          let searchBoxHeight = document.getElementById("searchBox") ? document.getElementById("searchBox").offsetHeight : 0;
          if (searchBoxHeight > 60) {
            searchBoxHeight = 56;
          }
          const toolbarHeight = document.getElementById("toolBar") ? document.getElementById("toolBar").offsetHeight : 0;
          this.maxHeight = clientHeight - toolbarHeight - searchBoxHeight - 144;
        }
      },

      // 重置
      resetHandle() {
        this.$emit("reset", JSON.parse(this.filterCopy));
        this.$nextTick(() => {
          this.loadData(1);
        });
      },

      // 全屏/还原
      fullScreen() {
        let fullscreenEnabled =
            document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled;
        if (fullscreenEnabled) {
          let element = document.getElementsByClassName("vm-main-page")[0];
          if (this.isFullscreen) {
            // 关闭全屏
            if (element.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
              document.webkitCancelFullScreen();
            }
          } else {
            if (element.requestFullscreen) {
              element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
              element.mozRequestFullScreen();
            } else if (element.webkitRequestFullScreen) {
              element.webkitRequestFullScreen();
            }
          }
          this.isFullscreen = !this.isFullscreen;
        }
      },

      // 打开导出模态框
      openExportDialog() {
        this.exportVisible = true;
        this.model.exportFields = [];
        this.allColumns.forEach((item) => {
          if (item.checked) {
            this.model.exportFields.push(item.name);
          }
        });
      },

      // 导出
      sureExport() {
        this.$refs.exportForm.validate((valid) => {
          if (valid) {
            this.exportLoading = true;
            let pageSize = this.filter.pageSize;
            let params = Object.assign(this.filter, {
              pageNum: 1,
              pageSize: 100000,
            });
            this.$http
                .exportExcel("basic", `${this.url}`, params, this.model.exportFields.join())
                .then((res) => {
                  const blob = new Blob([res.data]);
                  const downloadElement = document.createElement("a");
                  const href = window.URL.createObjectURL(blob);
                  const contentDisposition = res.headers["content-disposition"];
                  const fileName = decodeURI(contentDisposition.split("filename*=utf-8''")[1].split(".")[0]);
                  downloadElement.style.display = "none";
                  downloadElement.href = href;
                  downloadElement.download = fileName + ".xlsx"; // 下载后文件名
                  document.body.appendChild(downloadElement);
                  downloadElement.click(); // 点击下载
                  document.body.removeChild(downloadElement); // 下载完成移除元素
                  window.URL.revokeObjectURL(href); // 释放掉blob对象
                  this.exportVisible = false;
                  this.exportLoading = false;
                })
                .catch(() => {
                  this.exportVisible = false;
                }).finally(() => {
              this.filter.pageSize = pageSize;
            });
          }
        });
      },

      //行属性设置
      tableRowClassName(row) {
        let that = this;
        if ((that.url === "productionOrders" && row.purchaseStatus === "缺料")
            || (that.url === "purchaseOrders" && row.attachmentCount === 0)) {
          return "warning-row";
        }

        if (that.url === "purchaseOrderDetails" && row.sendedQuantity < row.qty) {
          let curDate = moment(new Date()).add(-3, "days").format("YYYY-MM-DD") + " 00:00:00";
          if (row.deliveryDate <= curDate) {
            return "warning-row";
          }
        }

        if (that.url === "productionManage/list"
            && (row.status === 10 || row.status === 20 || row.status === 30 || row.status === 40)) {
          let curDate = moment(new Date()).format("YYYY-MM-DD");
          if (curDate > row.planFinishTime) {
            return "warning-row";
          }

        }
      },
      // 表格数据选中时触发
      selectHandle(selection) {
        // console.log(selection);
        this.$emit("select", selection);
      },

      // 删除
      deleteHandle(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"})
            .then(() => {
              this.$emit("delete", row);
            })
            .catch(() => {
            });
      },

      // 展开与收起
      toggleMore() {
        this.searchShow = !this.searchShow;
        for (let i = 0; i < this.searchs.length; i++) {
          if (i > 3) {
            if (this.searchShow) {
              this.searchs[i].style.display = "inline-block";
            } else {
              this.searchs[i].style.display = "none";
            }
          }
        }
      },

      // 单击一行
      rowClick(row, index) {
        this.currentRowIndex = index;
      },
    },
  };
</script>

<style lang="scss">
.warning-row {
  color: red;
}

.viewTable {
  #searchBox {
    display: flex;
    background-color: #f4f7fa;
    padding: 10px 10px 5px 10px;
    border: 1px solid #e8e8e8;
    border-radius: 3px;
    margin-bottom: 5px;

    .el-form-item {
      margin-bottom: 5px;
    }

    .moreSearch {
      min-width: 200px;
      line-height: 29px;

      .actionDown {
        font-weight: bolder;
        margin-right: 5px;
      }
    }

    .el-input__inner {
      width: 180px;
    }

    .el-date-editor {
      width: 435px;
    }
  }

  #toolBar {
    min-height: 28px;
    display: flex;

    .left {
      flex: 1;
    }

    .right {
      width: 300px;
      display: flex;
      justify-content: flex-end;

      div {
        width: 30px;
        height: 28px;
        border-radius: 15px;
        border: 1px solid #e8e8e8;
        line-height: 28px;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
        margin-left: 10px;

        &:hover {
          color: #2d8cf0;
        }
      }
    }
  }

  .ivu-table td,
  .ivu-table th {
    height: 37px;
    font-size: 13px;

    .el-button--mini {
      padding: 7px 10px;
    }
  }

  #sortEl {
    .el-checkbox {
      cursor: move;
    }
  }

  .el-radio__label {
    padding-left: 0;
    display: none;
  }
}
</style>
